export function getAll() {
  return [
    {
      value: 0,
      name: "Long",
      text: "長租",
    },
    {
      value: 1,
      name: "Short",
      text: "短租",
    },
    {
      value: 2,
      name: "None",
      text: "不計算",
    },
  ];
}
